import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";
import { SimpleSiteHeader } from "@kaltura/../../libs/shared/simple-site-header/src/index";

export const Component = SimpleSiteHeader;

export const render = getStandaloneComponentRenderer(SimpleSiteHeader, true);
